export const environment = {
  api: {
    apiRootServer: import.meta.env.VITE_API_BASE_URL || 'https://backend.buildsupplyco.com/api/v1',
  },
  production: import.meta.env.PROD || false,
  razorpay: {
    keyId: import.meta.env.VITE_RAZORPAY_KEY_ID || 'rzp_test_or9M4h7lC47DT9',
  },
  app: {
    name: import.meta.env.VITE_APP_NAME || 'BuildZap',
    version: import.meta.env.VITE_APP_VERSION || '1.0.0',
    env: import.meta.env.VITE_APP_ENV || 'development'
  }
};

// Debug logging
